// extracted by mini-css-extract-plugin
module.exports = {"link":"_1410bfd27b--link--cH0DM","logo":"_1410bfd27b--logo--qSkas","text":"_1410bfd27b--text--UQaYt"};